import Image from 'next/image'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'

import BenetitItem from '@/atoms/BenefitItem'

function Benetits() {
  const { t } = useTranslation('wellBeing')

  const handleScroll = (scrollTo: string): void => {
    const element = document.getElementById(scrollTo)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <div className="flex flex-col-reverse items-center justify-center w-screen lg:py-8 ms:py-12 lg:flex-row bg-violet-60">
      <div className="flex items-center justify-center lg:w-1/2">
        <div className="w-64 h-64 2sm:w-72 2sm:h-72 md:w-96 md:h-96">
          <Image
            alt={t('results.none')}
            src={`/images/well-being/benefits.png`}
            height="10%"
            width="10%"
            layout="responsive"
            quality={75}
            loading="eager"
          />
        </div>
      </div>
      <div className="flex flex-col p-8 md:w-4/5 lg:w-1/2 2xl:w-2/3">
        <div className="flex flex-col">
          <Trans
            i18nKey="wellBeing:benefits_title"
            components={[
              <p
                className="flex flex-col flex-grow ml-1 text-lg font-bold text-white md:flex-row"
                key={0}
              />,
              <p key={1} className="text-lg font-normal text-white md:ml-1" />,
            ]}
          />
          <p className="flex-grow text-lg text-white">
            {t('benefits_title_1')}
          </p>
        </div>
        <div className="ml-1">
          <BenetitItem copy="benefits_copy_1" />
          <BenetitItem copy="benefits_copy_2" />
          <BenetitItem copy="benefits_copy_3" />
          <BenetitItem copy="benefits_copy_4" />
          <BenetitItem copy="benefits_copy_5" />
          <BenetitItem copy="benefits_copy_6" />
        </div>
        <div className="flex items-center justify-center p-8 lg:w-5/6">
          <button
            onClick={() => handleScroll('contact')}
            className="px-4 py-2 font-bold text-white uppercase md:px-6 md:py-3 md:text-lg bg-green-60"
          >
            {t('button_banner')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Benetits
